import { apiRequest } from '../axiosInstance';
import axiosInstance from '../axiosInstance';
import { EMAIL_ASSET_ENDPOINTS } from '../endpoints';

const emailAssetService = {
  getAll: async () => {
    return apiRequest(() =>
      axiosInstance.get(EMAIL_ASSET_ENDPOINTS.LIST)
    );
  },

  getUploadToken: async (fileName) => {
    return apiRequest(() =>
      axiosInstance.post(`${EMAIL_ASSET_ENDPOINTS.UPLOAD_TOKEN}?fileName=${encodeURIComponent(fileName)}`)
    );
  },

  register: async (data) => {
    return apiRequest(() =>
      axiosInstance.post(EMAIL_ASSET_ENDPOINTS.REGISTER, data)
    );
  },

  delete: async (id) => {
    return apiRequest(() =>
      axiosInstance.delete(EMAIL_ASSET_ENDPOINTS.DELETE(id))
    );
  },

  getUrl: async (id) => {
    return apiRequest(() =>
      axiosInstance.get(EMAIL_ASSET_ENDPOINTS.URL(id))
    );
  },
};

export default emailAssetService;
